var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossCircleSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM8.04853 6.35147C7.5799 5.88284 6.8201 5.88284 6.35147 6.35147C5.88284 6.8201 5.88284 7.5799 6.35147 8.04853L10.3029 12L6.35147 15.9515C5.88284 16.4201 5.88284 17.1799 6.35147 17.6485C6.8201 18.1172 7.5799 18.1172 8.04853 17.6485L12 13.6971L15.9515 17.6485C16.4201 18.1172 17.1799 18.1172 17.6485 17.6485C18.1172 17.1799 18.1172 16.4201 17.6485 15.9515L13.6971 12L17.6485 8.04853C18.1172 7.5799 18.1172 6.8201 17.6485 6.35147C17.1799 5.88284 16.4201 5.88284 15.9515 6.35147L12 10.3029L8.04853 6.35147Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossCircleSolid);
export default __webpack_public_path__ + "static/media/cross-circle-solid.964ed3dc12503f6ebdc3c8a184e04e35.svg";
export { ForwardRef as ReactComponent };